import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { OrientacionI } from "interfaces/Orientacion";
import { Dropdown } from "react-bootstrap";
import { deleteNormativa, openFile } from "services/normativas";
import { deleteOrientacion } from "services/orientacion";

interface Props {
  elemento: OrientacionI;
  onClickEdit: (elemento: OrientacionI) => void;
  refreshTable: () => void;
}

export const OrientacionesRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteOrientacion(id);
      showSuccessToast("¡La orientacion fue eliminada con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando la orientación: ", error.message);
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar orientacion"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar la orientacion {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
